import axios from 'axios'
import urlHelper from './urlHelper'

const baseUrl = urlHelper('/api/userpagenote')

export default {
  getList () {
    return axios.get(baseUrl)
  },
  getById (id) {
    return axios.get(`${baseUrl}/${id}`)
  },
  add (pageNumber, note) {
    return axios.post(`${baseUrl}`, { pageNumber, note })
  },
  delete (id) {
    return axios.delete(`${baseUrl}/${id}`)
  }
}
